//interfaces
import { ISocialContentPost } from '../../../../interfaces/information/ContentPostInformation';

//components
import ContentPostInformation from "./ContentPostInformation";
import BasicSocialButtonsPanel from "../../buttons/buttonPanels/BasicSocialButtonPanel";
import CaretButton from "../../buttons/CaretButton";


const SocialContentPost = ({className, contentPostInformation, contentTitle, socialInfo, viewContentButton, contentLink, contentButtonClick, children}: ISocialContentPost) => {

    return (
        <div className={`social-content-post-wrapper ${className}`} >
            <ContentPostInformation 
                {...contentPostInformation}
            />

            <h3 className="social-content-title">{contentTitle}</h3>

            {children}
        
            <div className="social-content-bottom-panel">
                <BasicSocialButtonsPanel 
                    {...socialInfo}
                />

                <CaretButton 
                    className="social-content-button-wrapper"
                    content={viewContentButton} 
                    ariaLabel={"View Content"}
                    isLink={!!contentLink}
                    linkUrl={contentLink}
                    onButtonClick={contentButtonClick}
                />
            </div>
        </div>
    );
};

export default SocialContentPost